import styled from 'styled-components';

export const FormContainer = styled.div`
  form {
    padding-bottom: 70px;

    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      padding-bottom: 0;
    }

    .formItem {
      width: 100%;
      margin: 0 0 10px;

      &.fullWidth {
        width: 100%;
      }

      @media (min-width: 768px) {
        width: calc(50% - 10px);
        margin: 0 5px 10px;
      }
    }

    .photoUploader {
      margin-top: 10px;
    }
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  margin: 15px auto 0;
  text-align: center;

  button {
    width: auto;
    padding: 15px 35px;
  }
`;
export const CloseModal = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export const ModalTitle = styled.h2`
  margin-top: 15px;
  margin-bottom: 25px;
  text-align: center;
  font-size: 23px;
`;

export const ErrorMessage = styled.div`
  padding: 3px 0;
  font-size: 12px;
  color: #ff3b30;
`;

export const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 30px)',
    maxWidth: '500px',
    minHeight: '250px',
    maxHeight: 'calc(100vh - 50px)',
    paddingBottom: '50px',
    overflow: 'auto'
  }
};

export const confirmModelStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 30px)',
    maxWidth: '400px',
    minHeight: '250px',
    maxHeight: 'calc(100vh - 50px)',
    paddingBottom: '15px',
    paddingTop: '30px',
    overflow: 'auto'
  }
};
